import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Alert, Button } from "reactstrap";

import playStoreQr from "../../assets/images/store/play-store-qr.png";
import {
  PLAY_STORE_URL,
  PLAY_STORE_WELCOME_DISMISS_KEY,
  PLAY_STORE_WELCOME_QUERY,
  PLAY_STORE_WELCOME_VALUE,
} from "../../helpers/playStore";

const SHOW_KEY = "adatis.playStore.welcome.show";

/**
 * Pós-cadastro: CTA para baixar o app na Play Store (dismissível na sessão).
 */
const WelcomePlayStoreBanner = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [visible, setVisible] = useState(false);

  const fromRegister = useMemo(
    () => searchParams.get(PLAY_STORE_WELCOME_QUERY) === PLAY_STORE_WELCOME_VALUE,
    [searchParams]
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (window.sessionStorage.getItem(PLAY_STORE_WELCOME_DISMISS_KEY) === "1") {
      setVisible(false);
      return;
    }

    if (fromRegister) {
      window.sessionStorage.setItem(SHOW_KEY, "1");
      setVisible(true);
      return;
    }

    setVisible(window.sessionStorage.getItem(SHOW_KEY) === "1");
  }, [fromRegister]);

  useEffect(() => {
    if (!fromRegister) {
      return;
    }

    const next = new URLSearchParams(searchParams);
    next.delete(PLAY_STORE_WELCOME_QUERY);
    setSearchParams(next, { replace: true });
  }, [fromRegister, searchParams, setSearchParams]);

  const handleDismiss = () => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(PLAY_STORE_WELCOME_DISMISS_KEY, "1");
      window.sessionStorage.removeItem(SHOW_KEY);
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Alert color="primary" className="d-flex flex-wrap align-items-center gap-3 mb-3">
      <img
        src={playStoreQr}
        alt={t("playStore.qrAlt")}
        width={88}
        height={88}
        className="rounded border bg-white p-1 flex-shrink-0"
      />
      <div className="flex-grow-1">
        <strong className="d-block mb-1">{t("playStore.welcomeTitle")}</strong>
        <p className="mb-2 small">{t("playStore.welcomeBody")}</p>
        <div className="d-flex flex-wrap gap-2">
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-primary"
          >
            <i className="ri-google-play-line me-1" />
            {t("playStore.downloadCta")}
          </a>
          <Button color="soft-secondary" size="sm" type="button" onClick={handleDismiss}>
            {t("playStore.dismiss")}
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default WelcomePlayStoreBanner;
